import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';
import { UtilitiesService } from '../services/utilities.service'


import { Tipo } from '../model/Tipo';

@Injectable()
export class TipoService {

  constructor(
    private _http: Http,
    private _utilities: UtilitiesService

  ) { }


  getTipos(): Observable<Tipo[]> {

    let json = { "Metodo": "getTipo", "Datos": {} };
    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).map(res => res.json());
  }

  public delete(tipo: Tipo) {

    let json = { "Metodo": "deleteTipo", "Datos": tipo };
    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this._http.post(this._utilities.getURL("post"),
      params, { headers: headers }).map(res => res.json());
  }


  public insert(tipo: Tipo) {

    let json = { "Metodo": "insertTipo", "Datos": tipo };
    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this._http.post(this._utilities.getURL("post"),
      params, { headers: headers }).map(res => res.json());
  }

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/services/tipo.service.ts